module.exports = __webpack_public_path__ + "img/10.9da6cf82.png";